import React from "react";
import cx from "classnames";

import { Heading } from "components/ui/Heading";
import { Section } from "components/common/Section";
import { Container } from "components/common/Container";
import Illustration from "svg/home-partners-waves.inline.svg";

import { IPartner, PartnerCard } from "./PartnerCard";
import { IArticle, PartnerReviewCard } from "./PartnerReviewCard";
import * as s from "./Partners.module.sass";

type PartnersProps = {
  partners: IPartner[];
  news: IArticle[];
  newsLink: string;
};

export const Partners: FC<PartnersProps> = ({
  partners,
  news,
  newsLink,
  className,
}) => (
  <Section className={cx(s.root, className)}>
    <Container className={cx(s.container, s.partnersWrapper)}>
      <Heading className={s.partnersHeader}>Our partners</Heading>
      <div className={s.partners}>
        {partners.map((partner) => (
          <PartnerCard
            key={partner.link}
            partner={partner}
            className={s.partner}
          />
        ))}
      </div>
    </Container>
    <div className={s.reviewsWrapper}>
      <Illustration className={s.illustration} />
      <Container className={s.container}>
        <Heading className={s.partnersHeader}>Our news</Heading>
      </Container>
      <div className={s.reviews}>
        <Container className={s.container}>
          {news.map((article) => (
            <PartnerReviewCard
              key={article.link}
              article={article}
              className={s.review}
            />
          ))}
        </Container>
      </div>

      <a
        href={newsLink}
        target="_blank"
        rel="nofollow noreferrer"
        className={s.button}
      >
        See all
      </a>
    </div>
  </Section>
);
